import { remove, sortedIndexBy } from 'lodash-es';
import moment from 'moment-timezone';

import { Form } from '@site-mate/dashpivot-shared-library';

import { FormWeb } from 'app/shared/model/form.model';

/**
 * TimelineGroup is a class storing an array of forms and a timestamp used for displaying
 * all forms as a standalone section
 */
export class TimelineGroup {
  forms: FormWeb[];
  timestamp: number;

  constructor(timestamp: number) {
    this.timestamp = timestamp;
    this.forms = [];
  }

  pushForm(form: Form) {
    this.forms.push(form);
  }

  pushFormInOrder(form: Form, sortByFn: (form: FormWeb) => number) {
    this.forms.splice(this.getInsertionIndex(form, sortByFn), 0, form);
    this.forms.sort(this.sortForms(sortByFn));
  }

  updateForm(updatedForm: Form, sortByFn: (form: FormWeb) => number) {
    const initialIndex = this.forms.findIndex(({ _id }) => _id === updatedForm._id);
    const insertionIndex = this.getInsertionIndex(updatedForm, sortByFn);

    if (initialIndex !== insertionIndex) {
      this.forms[initialIndex] = updatedForm;
      this.forms.sort(this.sortForms(sortByFn));
    } else {
      this.forms[initialIndex] = updatedForm;
    }
  }

  removeForm(formId: string) {
    remove(this.forms, ({ _id }) => _id === formId);
  }

  private sortForms(sortByFn): (form: Form, secondForm: Form) => number {
    return (form, secondForm) =>
      sortByFn(secondForm) - sortByFn(form) || +moment(secondForm.createdAt) - +moment(form.createdAt);
  }

  private getInsertionIndex(form: Form, sortByFn: (form: FormWeb) => number): number {
    // Sorted in DESC order
    return sortedIndexBy(this.forms, form, (f) => -sortByFn(f));
  }
}
